import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { fadeIn, staggerContainer, textVariant } from "./utils/motion";
import { useDispatch, useSelector } from "react-redux";
import About_imgs from "./About_imgs";
import { setSelected } from "../store/reducers/CartReducer";
import { VisionSection } from "./VisionSection";

export default function About ({lang}) {
    const dispatch = useDispatch()
    useEffect(() => {
    dispatch( setSelected({select:3}))
    }, []);
    const data = useSelector((state) => state.cart.constants);   
  

    return (
      <>
         <motion.div  variants={staggerContainer()}
   initial='hidden'
   whileInView='show'
   viewport={{ amount: 0.25 }}  className="  w-[100%] mt-[80px] px-[5%]  ">
  
  <span className='hash-span' id={'About'}>
   
   </span>

  
  <motion.div className="w-full bg-[#f4f4f4] p-4 rounded " variants={textVariant()}  dir={lang=== 'en' ?  "ltr" : "rtl" }>
       
       
  
  
         
<div  className="  rounded-tr-[50px] rounded-tl-[50px]">
                         
<h2 style={{fontFamily:'CairoExtraBold'}} className={`text-primary text-[20px] lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px]  ${lang=== 'en' ?  "text-left" : "text-right" } `}  > {lang==='en' ? 'About ' : 'من نحن'} </h2>
        
      <motion.p

          variants={fadeIn("right", "", 0.1, 1)}
          className= {` ${lang=== 'en' ?  "text-left" : "text-right" }  lg:text-[20px] md:text-[17px] sm:text-[15px] xs:[13px] text-[13px] font-bold`} 
        >
        {lang=== 'en' ?  data&&data.length ?  data&&data[0].value_en :'' 
        
        : data&&data.length ?  data&&data[0].value :'' }
         
        </motion.p>
        <motion.p
        
          variants={fadeIn("left", "", 0.1, 1)}
          className={`mt-3  ${lang=== 'en' ?  "text-right" : "text-left" } text-[13px] lg:text-[20px] md:text-[17px] sm:text-[15px] xs:[13px] text-[13px]  font-bold max-w-[1000px]l leading-[30px]`}
        >
     <span className="text-primary">
    {lang=== 'en'  ?  ' CEO / ':   ' المدير التنفيذي / '}
    </span>
  
         {lang=== 'en'  ?   data&&data.length ?  data&&data[6].value_en :''
        
        :  data&&data.length ?  data&&data[6].value :''}
     
        </motion.p>
        </div>
  <br></br>
  
   </motion.div>
     </motion.div>
  
    
  <About_imgs />
  
  
  <VisionSection />
                
      </>
    );
  };

